import GetSharePointNominations from './GetSharePointNominations'

class UpdateSharepointNomination extends GetSharePointNominations {
  requestUrl = `/api/SharepointNomination/${this.getParams().id}/${this.getParams().status}`

  method = 'PATCH'
}

export default UpdateSharepointNomination
